import { MigrationBase } from './base'
import { ConvrrtFirebase } from '../../../convrrt-firebase'
import _ from 'lodash'

export class CardListMigration extends MigrationBase {
  private cardItems: {
    template: {
      subHeadline?: {
        text: string
        enable: boolean
      }
      text?: string
      headline?: string
      button?: Object
      icon?: Object
      enableText?: boolean
      enableHeadline?: boolean
      enableButton?: boolean
      enableIcon?: boolean
    }
  }[]
  private _convrrtFirebase: ConvrrtFirebase
  private vnodeId: string

  constructor({
    firebaseKey,
    cardItems,
    vnodeId,
  }: {
    firebaseKey: string
    cardItems: any[]
    vnodeId: string
  }) {
    super()
    this.cardItems = cardItems
    this._convrrtFirebase = new ConvrrtFirebase(firebaseKey)
    this.vnodeId = vnodeId
  }
  async beforeMigration() {
    if (this.cardItems.some((item) => !item.template.subHeadline)) {
      this.setMessageLog('Backing up card list data...')

      await this.waitForAWhile(2000)

      if (this.siteRef) {
        await this.siteRef
          .child('migrations')
          .child('cardList')
          .child('version')
          .child(1)
          .child(this.vnodeId)
          .set(_.cloneDeep(this.cardItems))
      }

      await this.waitForAWhile(2000)
      this.setMessageLog('Card list data backed up successfully')
    }
  }

  async runMigration() {
    this.setMessageLog('Getting Ready to migrate card list data...')

    const newCardItems: any[] = []

    await this.waitForAWhile(5000)

    this.setMessageLog('Fixing Bullet Lists Data...')

    await this.waitForAWhile(2000)

    for (const item of this.cardItems) {
      let newTemplateData: any = { ...item }
      if (!item.template.subHeadline) {
        newTemplateData.template = {
          ...item.template,
          subHeadline: {
            text: item.template.text,
            enable: item.template.enableText || true,
          },
          headline: {
            text: item.template.headline,
            enable: item.template.enableHeadline || true,
          },
          button: {
            ...item.template.button,
            enable: item.template.enableButton || false,
          },
          icon: {
            ...item.template.icon,
            enable: item.template.enableIcon || true,
          },
        }
      }
      newCardItems.push(newTemplateData)
    }
    await this._convrrtFirebase.setChild(`cardItems`, newCardItems)
  }

  async onCompleted() {
    await this._convrrtFirebase.setChild(`version`, 2)
  }
}
